module.exports = __webpack_public_path__ + "img/sh.5b4f89c7.png";